/**
 * It generates an array of compounding values for the line (stacked) readiness chart, adding the values of each entry according to the readiness inputs
 * @example
 * generateChartArray(
 *   [
 *    { meta: "Aug 10, 2021", value: [1, 1, 1, 1, 1] },
 *    { meta: "Aug 11, 2021", value: [2, 3, 4, 5, 4] }
 *   ]
 * );
 * returns [
 * [
 *   { meta: "Aug 10, 2021", value: 5 },
 *   { meta: "Aug 11, 2021", value: 18 },
 * ],
 * [
 *   { meta: "Aug 10, 2021", value: 4 },
 *   { meta: "Aug 11, 2021", value: 14 },
 * ],
 * [
 *   { meta: "Aug 10, 2021", value: 3 },
 *   { meta: "Aug 11, 2021", value: 9 },
 * ],
 * [
 *   { meta: "Aug 10, 2021", value: 2 },
 *   { meta: "Aug 11, 2021", value: 5 },
 * ],
 * [
 *   { meta: "Aug 10, 2021", value: 1 },
 *   { meta: "Aug 11, 2021", value: 2 },
 * ],
 *];
 * @param {Object[]} - The array of objects to be on the chart.
 * @returns {Object[]} - Returns new array of objects.
 **/
export const generateChartArray = (array) => {
  let _array = array.map((obj) => {
    return obj.value.reduce((prev, next, i) => {
      if (i === 0) return [{ meta: obj.meta, value: parseInt(next) }];
      return [
        ...prev,
        {
          meta: obj.meta,
          value: parseInt(Number(next) + Number(prev[prev.length - 1].value)),
        },
      ];
    }, []);
  });

  const cat = [[], [], [], [], []];

  return cat
    .map((c, readinessIndex) => {
      return _array.map((st) => st[readinessIndex]);
    })
    .reverse();
};
